export const CURRENT_TERMS_VERSION = '2025-12-19';
